import { render, staticRenderFns } from "./SalePackage.vue?vue&type=template&id=082def6e&scoped=true&"
import script from "./SalePackage.vue?vue&type=script&lang=js&"
export * from "./SalePackage.vue?vue&type=script&lang=js&"
import style0 from "./SalePackage.vue?vue&type=style&index=0&id=082def6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082def6e",
  null
  
)

export default component.exports